/* eslint-disable */
// @ts-nocheck
//
// Beware, ye who dare to venture within this file,
// Tread lightly, dear traveler.
// For your mind, once in its grasp, may well be entangled by it's layers.
//

import { KeyNodeType } from '@overtur-monorepo/keying-shared'
import { Injectable } from '@angular/core'
import { BehaviorSubject, Subject } from 'rxjs'
import { take } from 'rxjs/operators'
import { MasterKey } from '../models/master-key'
import { group } from '@angular/animations'

//class for calculating thru nodes
/* istanbul ignore next */
class GroupedKeys {
  prefix: string
  suffix: string
  iterations: number[]
  thruNodes: string[]
  ids: number[]
}
//class for calculating thru nodes
/* istanbul ignore next */
class SlicedKey {
  originalKeySetSymbol: string
  prefix: string
  suffix: string
  iteration: string
  assigned: boolean
  type: number
  id: number
}
//class for calculating thru nodes
/* istanbul ignore next */
class PotentialKeyConfigs {
  prefix: string
  suffix: string
  iteration: string
}
//class for calculating thru nodes
/* istanbul ignore next */
class RawKeys {
  originalKeySetSymbol: string
  assigned: boolean
  type: number
  id: number
  configs: PotentialKeyConfigs[]
}

//class for calculating thru nodes
/* istanbul ignore next */
class ListKey {
  keySetSymbol: string
  assigned: boolean
  type: number
  id: number
}

@Injectable({
  providedIn: 'root',
})
export class MasterKeyService {
  keyNodeType = KeyNodeType

  masterKeys: BehaviorSubject<MasterKey> = new BehaviorSubject(null)
  masterKeys$ = this.masterKeys.asObservable()

  private selectedMasters: BehaviorSubject<MasterKey[]> = new BehaviorSubject([])
  selectedMasters$ = this.selectedMasters.asObservable()

  private selectedMasterKey: BehaviorSubject<MasterKey> = new BehaviorSubject(null)
  selectedMasterKey$ = this.selectedMasterKey.asObservable()

  private changeKeyParent: BehaviorSubject<MasterKey> = new BehaviorSubject(null)
  changeKeyParent$ = this.changeKeyParent.asObservable()

  /**
   * Subject for double-click key assignment feature.
   * Used for cross-component communication between lib-key (emitter) and
   * hierarchy.component (subscriber). This pattern is used instead of @Output
   * because lib-master-key-tree is recursive, making event propagation unreliable.
   * See: docs/features/DOUBLE_CLICK_KEY_ASSIGNMENT.md
   */
  private assignKeySubject: Subject<MasterKey> = new Subject()
  assignKey$ = this.assignKeySubject.asObservable()

  selectedChangeKeyType: 'Alike' | 'Different'

  settingMasterKeys = false
  debug = false

  rawKeys: RawKeys[] = []

  constructor() {}

  /* istanbul ignore next */
  setSelectedMasterKey(masterKey: MasterKey) {
    this.selectedMasterKey.next(masterKey)
  }

  /* istanbul ignore next */
  emitAssignKey(masterKey: MasterKey) {
    this.assignKeySubject.next(masterKey)
  }

  setMasterKeys(masterKeys: MasterKey) {
    if (this.debug) {
      console.log('RUNNING ALL FORMATTING:', masterKeys)
    }
    this.assignParents(masterKeys)
    masterKeys = this.formatItem(masterKeys)
    this.retainStatus(masterKeys)
    this.thruNodes(masterKeys)
    // console.log('AFTER THRU NODES:', masterKeys)
    this.sort(masterKeys)
    this.assignParents(masterKeys)
    this.trackLines(masterKeys)
    this.masterKeys.next(masterKeys)
  }

  // TODO: This is the beginings of work to improve optimisation of loading in the app.
  // async setMasterKeys(masterKeys: MasterKey) {
  //   if (masterKeys && !this.settingMasterKeys) {
  //     console.log('SET MASTER KEYS...')
  //     this.settingMasterKeys = true
  //     await this.runTasks(masterKeys)
  //     await this.masterKeys.next(masterKeys)
  //     this.settingMasterKeys = false
  //   }
  // }

  // async runTasks(masterKeys) {
  //   console.log('Starting Tasks...')
  //   await this.yieldToMain()
  //   await this.retainStatus(masterKeys)
  //   await this.yieldToMain()
  //   await this.thruNodes(masterKeys)
  //   await this.yieldToMain()
  //   await this.sort(masterKeys)
  //   await this.yieldToMain()
  //   await this.assignParents(masterKeys)
  //   await this.yieldToMain()
  //   await this.trackLines(masterKeys)
  //   await this.yieldToMain()
  // }

  retainStatus(newMasterKeys) {
    this.masterKeys$.pipe(take(1)).subscribe((oldMasterKeys) => {
      if (oldMasterKeys) {
        newMasterKeys.squash().map((nmk) => {
          // Assign Previous Atributes
          const match = oldMasterKeys.squash().find((omk) => omk.id === nmk.id)
          if (match) {
            nmk.isMinimized = match.isMinimized
          }
        })
      }
    })
  }

  // thruNodes(masterKey: MasterKey) {
  //   // Filter by type and assignment
  //   let assignedChangeKeys = masterKey.children.filter(
  //     (c) => c.isAssigned && (c.masterKeyTypeId === 8 || c.masterKeyTypeId === 10) && !c.isFutureKey
  //   )
  //   assignedChangeKeys.sort((a, b) => a.keySetSymbol.length - b.keySetSymbol.length)
  //   let unassignedChangeKeys = masterKey.children.filter(
  //     (c) => !c.isAssigned && (c.masterKeyTypeId === 8 || c.masterKeyTypeId === 10) && !c.isFutureKey
  //   )
  //   unassignedChangeKeys.sort((a, b) => a.keySetSymbol.length - b.keySetSymbol.length)
  //   let assignedSkdKeys = masterKey.children.filter((c) => c.isAssigned && c.masterKeyTypeId === 6 && !c.isFutureKey)
  //   assignedSkdKeys.sort((a, b) => a.keySetSymbol.length - b.keySetSymbol.length)
  //   let unassignedSkdKeys = masterKey.children.filter((c) => !c.isAssigned && c.masterKeyTypeId === 6 && !c.isFutureKey)
  //   unassignedSkdKeys.sort((a, b) => a.keySetSymbol.length - b.keySetSymbol.length)

  //   let assignedFutureKeys = masterKey.children.filter((c) => c.isAssigned && c.masterKeyTypeId === 0)
  //   assignedFutureKeys.sort((a, b) => a.keySetSymbol.length - b.keySetSymbol.length)
  //   let unAssignedFutureKeys = masterKey.children.filter((c) => !c.isAssigned && c.masterKeyTypeId === 0)
  //   unAssignedFutureKeys.sort((a, b) => a.keySetSymbol.length - b.keySetSymbol.length)

  //   // // Split by Key Set Symbol
  //   let assignedChangeSplitNodes = this.splitNodes(assignedChangeKeys)
  //   let unassignedChangeSplitNodes = this.splitNodes(unassignedChangeKeys)
  //   let assignedSkdSplitNodes = this.splitNodes(assignedSkdKeys)
  //   let unassignedSkdSplitNodes = this.splitNodes(unassignedSkdKeys)

  //   let assignedFutureKeyNodes = this.splitNodes(assignedFutureKeys)
  //   let unAssignedFutureKeyNodes = this.splitNodes(unAssignedFutureKeys)

  //   // // Calculate Thru Nodes
  //   assignedChangeSplitNodes.forEach((node) => this.evaluateNodes(masterKey, node, 99, true))
  //   unassignedChangeSplitNodes.forEach((node) => this.evaluateNodes(masterKey, node, 99))
  //   assignedSkdSplitNodes.forEach((node) => this.evaluateNodes(masterKey, node, 100, true))
  //   unassignedSkdSplitNodes.forEach((node) => this.evaluateNodes(masterKey, node, 100))

  //   assignedFutureKeyNodes.forEach((node) => this.evaluateNodes(masterKey, node, 101, true))
  //   unAssignedFutureKeyNodes.forEach((node) => this.evaluateNodes(masterKey, node, 101))

  //   masterKey.children.forEach((child) => {
  //     this.thruNodes(child)
  //   })
  //   this.processHierarchy(masterKey)
  // }

  thruNodes(masterKey: MasterKey) {
    // Initialize a high count for range-based nodes to assign unique IDs
    let count = 1000000000000
    if (!masterKey) return // Exit if masterKey is null or undefined

    if (masterKey.thruNotation && masterKey.thruNotation.length > 0) {
      if (!masterKey.children) {
        masterKey.children = []
      }

      masterKey.thruNotation.forEach((notation) => {
        const thruNode = new MasterKey()
        thruNode.keySetSymbol = notation.displayText

        // Determine masterKeyTypeId
        if (notation.masterKeyTypeId === 10 || notation.masterKeyTypeId === 8) {
          thruNode.masterKeyTypeId = this.keyNodeType.ChangeKeyThruNode
          thruNode.isChangeKey = true
        } else if (notation.masterKeyTypeId === 6) {
          thruNode.masterKeyTypeId = this.keyNodeType.SingleKeyDifferentThruNode
          thruNode.isSingleKeyDifferent = true
        } else {
          thruNode.masterKeyTypeId = notation.masterKeyTypeId
        }

        // Set assignment status
        thruNode.isAssigned = notation.isAssigned

        // Assign a unique ID
        // Id is used for editing/deleting individual nodes, so single thru nodes need to retain their orginal ID
        if (notation.isRange === true) {
          count++
          thruNode.id = count + notation.masterKeyTypeId
        } else if (notation.masterKeyTypeId === 10 || notation.masterKeyTypeId === 8) {
          thruNode.id = notation.id !== undefined && notation.id !== null ? notation.id + '99' : ++count
        } else if (notation.masterKeyTypeId === 6) {
          thruNode.id = notation.id !== undefined && notation.id !== null ? notation.id + '100' : ++count
        } else {
          thruNode.id = notation.id !== undefined && notation.id !== null ? notation.id : ++count
        }

        // Set optional properties
        thruNode.prefix = notation.prefix ?? ''
        thruNode.suffix = notation.suffix ?? ''
        thruNode.from = notation.startNumber ?? ''
        thruNode.to = notation.endNumber ?? ''
        thruNode.isRange = notation.isRange

        // Add to children if not duplicate
        const existingIndex = masterKey.children.findIndex(
          (child) =>
            Number(child.id) === Number(thruNode.id) &&
            Number(child.masterKeyTypeId) === Number(thruNode.masterKeyTypeId) &&
            (child.keySetSymbol ?? '') === (thruNode.keySetSymbol ?? '')
        )

        if (existingIndex === -1) {
          masterKey.children.push(thruNode)
        } else {
          // Update existing node properties if needed
          Object.assign(masterKey.children[existingIndex], thruNode)
        }
      })
    }

    // Recursively process children
    ;(masterKey.children || []).forEach((c) => this.thruNodes(c))

    // Finalize hierarchy processing
    this.processHierarchy(masterKey)
  }

  sortThruNodes(masterKey) {
    let sorted = masterKey.children
      .filter((k) => k.masterKeyTypeId === 99 || k.masterKeyTypeId === 100 || k.masterKeyTypeId === 101)
      .sort((a, b) => {
        return b.keySetSymbol.localeCompare(a.keySetSymbol, undefined, { numeric: true })
      })

    sorted.forEach((sortedKey) => {
      if (masterKey.children.filter((si) => si.id === sortedKey.id).length === 1) {
        let fromIndex = masterKey.children.findIndex((si) => si.id === sortedKey.id)
        masterKey.children = this.arrayMove(masterKey.children, fromIndex, masterKey.children.length)
      }
    })

    return masterKey
  }

  arrayMove(array, fromIndex, toIndex) {
    array.splice(toIndex, 0, array.splice(fromIndex, 1)[0])
    return array
  }

  splitNodes(keys) {
    let nodes = {}

    keys.sort((a, b) => {
      return a.keySetSymbol.localeCompare(b.keySetSymbol, undefined, { numeric: true })
    })

    keys.forEach((key, index) => {
      let letters = this.processString(key.keySetSymbol)

      if (index > 0) {
        let prevLetters = this.processString(keys[index - 1].keySetSymbol)

        /* istanbul ignore next */
        if (this.debug) {
          console.log('prevLetters', prevLetters)
        }

        letters = this.removeMismatchedLastNumber(letters, prevLetters)
      } else if (keys[index + 1]) {
        let nextLetters = this.processString(keys[index + 1].keySetSymbol)

        /* istanbul ignore next */
        if (this.debug) {
          console.log('nextLetters', nextLetters)
        }

        letters = this.removeMismatchedLastNumber(letters, nextLetters)
      }

      if (!nodes[letters]) {
        nodes[letters] = []
      }

      /* istanbul ignore next */
      if (this.debug) {
        console.log('Node Slot:', letters)
      }

      nodes[letters].push(key)
    })

    return Object.values(nodes)
  }

  processString(input) {
    const lastLetterIndex = input.match(/[a-zA-Z][^a-zA-Z]*$/)?.index
    if (lastLetterIndex === undefined) {
      return ''
    }

    const prefix = input.slice(0, lastLetterIndex + 1)
    const suffix = input.slice(lastLetterIndex + 1)

    const prefixHasDigits = /\d/.test(prefix)
    const suffixHasNonLetters = /[^a-zA-Z]/.test(suffix)

    const cleanedPrefix = prefixHasDigits ? prefix.replace(/\d/g, '') : prefix
    const cleanedSuffix = prefixHasDigits
      ? suffix.replace(/[^0-9]/g, '')
      : suffixHasNonLetters
      ? suffix.replace(/[^a-zA-Z]/g, '')
      : suffix

    return cleanedPrefix + cleanedSuffix
  }

  removeMismatchedLastNumber(input, reference) {
    // Check if the last character in both input and reference strings is a number
    const lastCharInput = input.slice(-1)
    const lastCharReference = reference.slice(-1)

    if (/\d/.test(lastCharInput) && /\d/.test(lastCharReference)) {
      // Check if the rest of the input and reference strings are the same and the last characters (numbers) do not match
      const restOfInput = input.slice(0, 0)
      const restOfReference = reference.slice(0, 0)

      if (restOfInput === restOfReference && lastCharInput !== lastCharReference) {
        // If the rest of the input and reference strings are the same and the last characters (numbers) do not match,
        // remove the last character from the input string
        return restOfInput
      }
    }

    // If the last characters are not numbers, the rest of the strings are not the same, or they match,
    // return the input string unchanged
    return input
  }

  /* istanbul ignore next */
  populateRK(keys: Listkey[]): RawKeys[] {
    // let rks = new Array<RawKeys>();
    let rks = Array.from<RawKeys>([])
    for (const key of keys) {
      let rk = new RawKeys()
      rk.originalKeySetSymbol = key.keySetSymbol
      rk.assigned = key.assigned
      rk.type = key.type
      rk.id = key.id
      rk.configs = []

      const s = this.findSuffixes(key.keySetSymbol)
      let containsNumbers = key.keySetSymbol.match(/\d+/g)

      if (!containsNumbers) {
        let pkc = new PotentialKeyConfigs()
        pkc.prefix = key.keySetSymbol
        pkc.suffix = ''
        pkc.iteration = ''
        rk.configs.push(pkc)
      } else {
        for (const suffix of s) {
          let pkc = new PotentialKeyConfigs()
          let cleanStr = key.keySetSymbol.substring(0, key.keySetSymbol.length - suffix.length)
          pkc.prefix = this.getPrefix(cleanStr)
          // console.log("Prefix?", pkc.prefix);
          pkc.iteration = cleanStr.substring(pkc.prefix.length, cleanStr.length)
          pkc.suffix = suffix
          rk.configs.push(pkc)
        }
        // for (let j = 0; j < s.length; j++) {
        //   let pkc = new PotentialKeyConfigs();
        //   let cleanStr = keys[i].keySetSymbol.substring(0, keys[i].keySetSymbol.length - s[j].length);
        //   pkc.prefix = this.getPrefix(cleanStr);
        //   // console.log("Prefix?", pkc.prefix);
        //   pkc.iteration = cleanStr.substring(pkc.prefix.length, cleanStr.length);
        //   pkc.suffix = s[j];
        //   rk.configs.push(pkc);
        // }
      }
      rks.push(rk)
    }

    return rks
  }

  /* istanbul ignore next */
  findSuffixes(key: string) {
    // console.log("KEY: ", key);
    let suffixes: string[] = []
    let indexCheck = 1
    //If character at the last index is a number, then the suffix is an empty string or doesnt exist
    if (this.isNumber(key.charAt(key.length - 1))) {
      suffixes.push('')
      indexCheck++
    }
    while (indexCheck <= key.length) {
      //if the character at the current index is a number, then the suffix is the characters after the current index
      if (this.isNumber(key[key.length - indexCheck])) {
        suffixes.push(key.substring(key.length - indexCheck + 1))
      }
      indexCheck++
    }
    // console.log("SUFFIXES: ", suffixes);
    return suffixes
  }

  /* istanbul ignore next */
  getPrefix(noSuffix: string): string {
    // console.log("Prefix", noSuffix);
    let i = 1
    let letterFound = false
    while (i <= noSuffix.length && !letterFound) {
      // console.log(noSuffix[noSuffix.length - i]);
      if (!this.isNumber(noSuffix[noSuffix.length - i])) {
        // console.log("Set Prefix", noSuffix.substring(0, noSuffix.length - i + 1));
        letterFound = true
        return noSuffix.substring(0, noSuffix.length - i + 1)
      }
      i++
    }
    return ''
  }

  /* istanbul ignore next */
  getFinalKeys(rawKeys: RawKeys[]): SlicedKey[] {
    if (this.debug) {
      console.log('getting final keys')
      console.log(rawKeys)
    }
    let slicedKeys: SlicedKey[] = []
    let maxConfigLength = this.getConfigsMaxLength(rawKeys)
    //compare key configs to each other to find the potential matches
    //highest potential match count wins
    //loop through all keys (i)
    for (let i = 0; i < rawKeys.length; i++) {
      let counts = []
      //loop through all configs (j)
      for (let j = 0; j < rawKeys[i].configs.length; j++) {
        counts.push(0)
        //loop through all other keys (k)
        for (let k = 0; k < rawKeys.length; k++) {
          if (
            k !== i &&
            rawKeys[k].configs.find(
              (x) =>
                x.prefix === rawKeys[i].configs[j].prefix &&
                x.suffix === rawKeys[i].configs[j].suffix &&
                x.iteration !== rawKeys[i].configs[j].iteration
            )
          ) {
            counts[j]++
          }
          // if (k !== i) {
          //   if (
          //     rawKeys[k].configs.find(
          //       (x) =>
          //         x.prefix === rawKeys[i].configs[j].prefix &&
          //         x.suffix === rawKeys[i].configs[j].suffix &&
          //         x.iteration !== rawKeys[i].configs[j].iteration,
          //     )
          //   ) {
          //     counts[j]++;
          //   }
          // }
        }
      }
      // console.log("rawKeys: ", rawKeys[i]);
      // console.log("COUNTS: ", counts);
      let winnerIndex = this.findIndexOfMax(counts)
      if (this.debug) {
        console.log('WINNER INDEX', winnerIndex)
      }
      let slicedKey = new SlicedKey()
      slicedKey.originalKeySetSymbol = rawKeys[i].originalKeySetSymbol
      slicedKey.prefix = rawKeys[i].configs[winnerIndex].prefix
      slicedKey.suffix = rawKeys[i].configs[winnerIndex].suffix
      slicedKey.iteration = rawKeys[i].configs[winnerIndex].iteration
      slicedKey.assigned = rawKeys[i].assigned
      slicedKey.type = rawKeys[i].type
      slicedKey.id = rawKeys[i].id
      if (this.debug) {
        console.log('FINAL KEY', slicedKey)
      }
      slicedKeys.push(slicedKey)
    }
    return slicedKeys
  }

  /* istanbul ignore next */
  getConfigsMaxLength(rawKeys: RawKeys[]): number {
    let maxLength = rawKeys[0].configs.length
    for (let i = 1; i < rawKeys.length; i++) {
      if (rawKeys[i].configs.length > maxLength) {
        maxLength = rawKeys[i].configs.length
      }
    }
  }

  /* istanbul ignore next */
  findIndexOfMax(counts: number[]): number {
    let maxIndex = 0
    for (let i = 1; i < counts.length; i++) {
      if (counts[i] > counts[maxIndex]) {
        maxIndex = i
      }
    }
    return maxIndex
  }

  //Groups by prefixes
  /* istanbul ignore next */
  groupKeys(slicedKeys: SlicedKey[]): GroupedKeys[] {
    let gks: GroupedKeys[] = []
    for (const slicedKey of slicedKeys) {
      // If assigned and change keys
      if (
        gks.find(
          (x) =>
            x.prefix === slicedKey.prefix &&
            x.suffix === slicedKey.suffix &&
            x.assigned === slicedKey.assigned &&
            x.type === slicedKey.type
        )
      ) {
        let groupIndex = gks.findIndex((x) => x.prefix === slicedKey.prefix && x.suffix === slicedKey.suffix)
        // Typecast iteration
        gks[groupIndex].iterations.push(Number(slicedKey.iteration))
        gks[groupIndex].assigned = slicedKey.assigned
        gks[groupIndex].type = slicedKey.type
        gks[groupIndex].ids.push(Number(slicedKey.id))
      } else {
        let gk = new GroupedKeys()
        gk.prefix = slicedKey.prefix
        gk.suffix = slicedKey.suffix
        gk.assigned = slicedKey.assigned
        gk.type = slicedKey.type
        gk.iterations = [Number(slicedKey.iteration)]
        gk.ids = [Number(slicedKey.id)]
        gk.thruNodes = []
        gks.push(gk)
      }
    }
    // for (let i = 0; i < slicedKeys.length; i++) {
    //   //if assigned and change keys
    //   if (
    //     gks.find(
    //       (x) =>
    //         x.prefix === slicedKeys[i].prefix &&
    //         x.suffix === slicedKeys[i].suffix &&
    //         x.assigned === slicedKeys[i].assigned &&
    //         x.type === slicedKeys[i].type,
    //     )
    //   ) {
    //     let groupIndex = gks.findIndex(
    //       (x) =>
    //         x.prefix === slicedKeys[i].prefix &&
    //         x.suffix === slicedKeys[i].suffix,
    //     );
    //     //typecast iteration
    //     gks[groupIndex].iterations.push(Number(slicedKeys[i].iteration));
    //     gks[groupIndex].assigned = slicedKeys[i].assigned;
    //     gks[groupIndex].type = slicedKeys[i].type;
    //     gks[groupIndex].ids.push(Number(slicedKeys[i].id));
    //   }
    //   else {
    //     let gk = new GroupedKeys();
    //     gk.prefix = slicedKeys[i].prefix;
    //     gk.suffix = slicedKeys[i].suffix;
    //     gk.assigned = slicedKeys[i].assigned;
    //     gk.type = slicedKeys[i].type;
    //     gk.iterations = [Number(slicedKeys[i].iteration)];
    //     gk.ids = [Number(slicedKeys[i].id)];
    //     gk.thruNodes = [];
    //     gks.push(gk);
    //   }
    // }
    return gks
  }

  /* istanbul ignore next */
  setGkthruNodes(gks: GroupedKeys[]): GroupedKeys[] {
    for (const gk of gks) {
      // Sort iterations in ascending order
      // 1,2,3,4,9,10,11,23,etc
      gk.iterations.sort((a, b) => a - b)
      let j = 0
      // Finding the start and the end of a thru node
      // also checks if there is only 1 iteration, therefore no thru node needed
      while (j < gk.iterations.length) {
        let start = gk.iterations[j]
        let startId = gk.ids[j]
        // While next - 1 === 1, continue. When not, construct string and push to array
        while (gk.iterations[j + 1] - gk.iterations[j] === 1) {
          j++
        }
        let end = gk.iterations[j]
        let endId = gk.ids[j]
        if (start !== end) {
          let thruNode = `${gk.prefix}${start}${gk.suffix}-${gk.prefix}${end}${gk.suffix}`
          // Calculate id that is equal to the id at the start index plus id at the end index
          if (this.debug) {
            console.log('IDS: ', `${startId}${endId}${gk.type}`)
          }
          gk.thruNodes.push({
            thruNode: thruNode,
            id: `${startId}${endId}${gk.type}`,
            prefix: gk.prefix,
            suffix: gk.suffix,
            from: start,
            to: end,
          })
        } else {
          if (gk.iterations[0] !== 0) {
            let thruNode = `${gk.prefix}${start}${gk.suffix}`
            gk.thruNodes.push({
              thruNode: thruNode,
              id: `${gk.ids[j]}`,
              prefix: gk.prefix,
              suffix: gk.suffix,
              from: start,
              to: end,
            })
          } else {
            let thruNode = `${gk.prefix}${gk.suffix}`
            gk.thruNodes.push({
              thruNode: thruNode,
              id: `${gk.ids[j]}`,
              prefix: gk.prefix,
              suffix: gk.suffix,
              from: start,
              to: end,
            })
          }
        }
        j++
      }
    }
    // for (let i = 0; i < gks.length; i++) {
    //   //sort iterations in ascending order
    //   //1,2,3,4,9,10,11,23,etc
    //   gks[i].iterations.sort((a, b) => a - b);
    //   let j = 0;
    //   //Finding the start and the end of a thru node
    //   //also checks if there is only 1 iteration, therefore no thru node needed
    //   while (j < gks[i].iterations.length) {
    //     let start = gks[i].iterations[j];
    //     let startId = gks[i].ids[j];
    //     //while next - 1 === 1, continue. when not, construct string and push to array
    //     while (gks[i].iterations[j + 1] - gks[i].iterations[j] === 1) {
    //       j++;
    //     }
    //     let end = gks[i].iterations[j];
    //     let endId = gks[i].ids[j];
    //     if (start !== end) {
    //       let thruNode = `${gks[i].prefix}${start}${gks[i].suffix}-${gks[i].prefix}${end}${gks[i].suffix}`;
    //       // calculate id that is equal to the id at the start index plus id at the end index
    //       if(this.debug) {
    //         console.log("IDS: ", `${startId}${endId}${gks[i].type}`);
    //       }
    //       gks[i].thruNodes.push({thruNode: thruNode, id: `${startId}${endId}${gks[i].type}`});
    //       // gks[i].thruNodes.push({thruNode: thruNode, id: gks[i].id + gks[i].ids[gks[i].ids.length - 1]});
    //     } else {
    //       if(gks[i].iterations[0] !== 0) {
    //       let thruNode = `${gks[i].prefix}${start}${gks[i].suffix}`;
    //       gks[i].thruNodes.push({thruNode: thruNode, id: `${gks[i].ids[j]}${gks[i].type}`});
    //       }
    //       else {
    //         let thruNode = `${gks[i].prefix}${gks[i].suffix}`;
    //         gks[i].thruNodes.push({thruNode: thruNode, id: `${gks[i].ids[j]}${gks[i].type}`});
    //       }
    //     }
    //     j++;
    //   }
    // }
    return gks
  }

  /* istanbul ignore next */
  isNumber(str: string): boolean {
    let num = Number(str)
    //is not NAN
    return !isNaN(num)
  }

  /* istanbul ignore next */
  evaluateNodes(parent, children, type, assigned = false) {
    let startingIndex = 0
    let endingIndex = 0

    children.sort((a, b) => {
      return a.keySetSymbol.localeCompare(b.keySetSymbol, undefined, { numeric: true })
    })
    let listKeys: listKey[] = []
    children.forEach((key, index) => {
      let listKey = new ListKey()
      listKey.keySetSymbol = key.keySetSymbol
      listKey.assigned = assigned
      listKey.type = type
      listKey.id = key.id
      listKeys.push(listKey)
    })
    // console.log("LISTKEYS: ", listKeys);
    const rks = this.populateRK(listKeys)
    //  console.log("RKS: ", rks);
    const slicedKeys = this.getFinalKeys(rks)
    if (this.debug) {
      console.log('KEYS COUNT', listKeys.length)
      console.log('SLICED KEYS COUNT', slicedKeys.length)
      console.log('SLICEDKEYS: ', slicedKeys)
    }

    let gks = this.groupKeys(slicedKeys)
    //sort gks by prefix
    gks = this.setGkthruNodes(gks)
    if (this.debug) {
      console.log('FINAL', gks)
    }
    this.addThruNodes(parent, gks)
  }

  calcNodes(parent, children, type, assigned = false) {
    let startingIndex = 0
    let endingIndex = 0

    children.sort((a, b) => {
      return a.keySetSymbol.localeCompare(b.keySetSymbol, undefined, { numeric: true })
    })

    children.forEach((key, index) => {
      let dif
      let numOne
      let numTwo

      if (index > 0) {
        numOne = this.removeAfterLastLetter(key.keySetSymbol, children[index - 1].keySetSymbol)
        numTwo = this.removeAfterLastLetter(children[index - 1].keySetSymbol, key.keySetSymbol)

        /* istanbul ignore next */
        if (this.debug) {
          console.log(key.keySetSymbol, numOne, children[index - 1].keySetSymbol, numTwo)
        }

        let backReference = numOne
        numOne = this.removeNumbersBeforeFirstLetter(numOne, numTwo)
        numTwo = this.removeNumbersBeforeFirstLetter(numTwo, backReference)

        /* istanbul ignore next */
        if (this.debug) {
          console.log(key.keySetSymbol, numOne, children[index - 1].keySetSymbol, numTwo)
        }

        numOne = Number(numOne.replace(/[^0-9]/g, ''))
        numTwo = Number(numTwo.replace(/[^0-9]/g, ''))

        dif = numOne - numTwo

        /* istanbul ignore next */
        if (this.debug) {
          console.log(
            key.keySetSymbol,
            numOne,
            children[index - 1].keySetSymbol,
            numTwo,
            'dif:',
            dif,
            'pow:',
            this.powerOfTen(dif),
            'correctDigits:',
            this.correctDigits(index, dif, numOne, numTwo)
          )
        }
      }
      if (index > 0 && (!this.powerOfTen(dif) || !this.correctDigits(index, dif, numOne, numTwo))) {
        endingIndex = index - 1
        this.createThruNode(parent, children, startingIndex, endingIndex, type, assigned)
        startingIndex = index
      }
      if (index + 1 === children.length) {
        endingIndex = index
        this.createThruNode(parent, children, startingIndex, endingIndex, type, assigned)
      }
    })
  }

  powerOfTen(dif) {
    return Math.log10(dif) % 1 === 0
  }

  correctDigits(index, dif, numOne, numTwo) {
    // console.log(index, dif.toString().length, numOne.toString().length)
    if (dif === 1 || dif.toString().length < numOne.toString().length) {
      return true
    } else {
      return false
    }
  }

  removeAfterLastLetter(input, reference) {
    const lastLetterIndexInput = input.search(/[a-zA-Z][^a-zA-Z]*$/)
    const lastLetterIndexReference = reference.search(/[a-zA-Z][^a-zA-Z]*$/)

    if (lastLetterIndexInput === -1 || lastLetterIndexReference === -1) {
      return input
    }

    const suffixInput = input.slice(lastLetterIndexInput + 1)
    const suffixReference = reference.slice(lastLetterIndexReference + 1)

    if (suffixInput === suffixReference) {
      return input.slice(0, lastLetterIndexInput + 1)
    }

    return input
  }

  removeNumbersBeforeFirstLetter(input, reference) {
    const firstLetterIndexInput = input.search(/[a-zA-Z]/)
    const firstLetterIndexReference = reference.search(/[a-zA-Z]/)

    if (firstLetterIndexInput === -1 || firstLetterIndexReference === -1) {
      return input
    }

    const prefixInput = input.slice(0, firstLetterIndexInput)
    const prefixReference = reference.slice(0, firstLetterIndexReference)

    if (prefixInput !== prefixReference) {
      return input
    }

    const cleanedPrefixInput = prefixInput.replace(/\d/g, '')
    const suffixInput = input.slice(firstLetterIndexInput)

    return cleanedPrefixInput + suffixInput
  }

  /* istanbul ignore next */
  addThruNodes(masterKey: MasterKey, groupedKeys: GroupedKeys[], type, assigned) {
    if (groupedKeys.length > 0 && masterKey.masterKeyTypeId !== type) {
      for (const groupedKey of groupedKeys) {
        for (const thruNodeElement of groupedKey.thruNodes) {
          if (this.debug) {
            console.log('TN: ', thruNodeElement)
          }
          let thruNode = new MasterKey()
          thruNode.keySetSymbol = thruNodeElement.thruNode
          thruNode.masterKeyTypeId = groupedKey.type
          thruNode.isAssigned = groupedKey.assigned
          thruNode.id = thruNodeElement.id
          thruNode.prefix = thruNodeElement.prefix
          thruNode.suffix = thruNodeElement.suffix
          thruNode.to = thruNodeElement.to
          thruNode.from = thruNodeElement.from
          //check if the thru node is already in the master key children array, if not, add it
          if (
            !masterKey.children.some(
              (child) =>
                child.keySetSymbol === thruNode.keySetSymbol && child.masterKeyTypeId === thruNode.masterKeyTypeId
            )
          ) {
            masterKey.children.push(thruNode)
          }
          if (this.debug) {
            console.log('thruNode', thruNode)
          }
        }
      }
      // for(let i = 0; i < groupedKeys.length; i++) {
      //     for(let j = 0; j < groupedKeys[i].thruNodes.length; j++) {
      //       if(this.debug) {
      //         console.log("TN: ", groupedKeys[i].thruNodes[j]);
      //       }
      //         let thruNode = new MasterKey()
      //         thruNode.keySetSymbol = groupedKeys[i].thruNodes[j].thruNode;
      //         thruNode.masterKeyTypeId = groupedKeys[i].type;
      //         thruNode.isAssigned = groupedKeys[i].assigned;
      //         thruNode.id = groupedKeys[i].thruNodes[j].id;
      //         masterKey.children.push(thruNode);
      //         if(this.debug) {
      //           console.log("thruNode", thruNode);
      //         }
      //   }
      // }
    }
  }

  createThruNode(masterKey, keys, startingIndex, endingIndex, type, assigned) {
    let thruNode = new MasterKey()
    thruNode.masterKeyTypeId = type

    if (keys.length > 0 && masterKey.masterKeyTypeId !== type) {
      let firstEle = keys[startingIndex]
      let lastEle = keys[endingIndex]

      thruNode.id = Number(firstEle.id.toString() + lastEle.id.toString() + type)

      if (firstEle.keySetSymbol === lastEle.keySetSymbol) {
        thruNode.keySetSymbol = `${firstEle.keySetSymbol}`
      } else {
        thruNode.keySetSymbol = `${firstEle.keySetSymbol}-${lastEle.keySetSymbol}`
      }

      thruNode.thruKeys = []

      keys.forEach((key, index) => {
        if (index >= startingIndex && index <= endingIndex) {
          thruNode.thruKeys.push(key)
        }
      })

      if (assigned) {
        thruNode.isAssigned = true
      }

      if (!masterKey.children.some((c) => c.id === thruNode.id)) {
        masterKey.children.push(thruNode)
      }
    }
  }

  sort(masterKey: MasterKey) {
    if (!masterKey.children) {
      return
    }

    // Sort Thru Nodes
    masterKey = this.sortThruNodes(masterKey)

    if (masterKey.level === 0) {
      masterKey.children.sort((a, b) =>
        a.masterKeyTypeId === this.keyNodeType.ChangeKeyThruNode
          ? -1
          : b.masterKeyTypeId === this.keyNodeType.ChangeKeyThruNode
          ? 1
          : 0
      )
      masterKey.children.sort((a, b) =>
        a.masterKeyTypeId === this.keyNodeType.SingleKeyDifferentThruNode
          ? -1
          : b.masterKeyTypeId === this.keyNodeType.SingleKeyDifferentThruNode
          ? 1
          : 0
      )
    }

    // General Sort of MKs
    // masterKey.children.sort((a, b) => a.keySetSymbol.length - b.keySetSymbol.length)
    masterKey.children.sort((a, b) => {
      return a.keySetSymbol.localeCompare(b.keySetSymbol, undefined, { numeric: true })
    })

    // Move SKD nodes to the top
    masterKey.children.sort((a, b) => {
      if (
        a.masterKeyTypeId === this.keyNodeType.SingleKeyDifferentMaster &&
        b.masterKeyTypeId !== this.keyNodeType.SingleKeyDifferentMaster
      )
        return -1
      if (
        b.masterKeyTypeId === this.keyNodeType.SingleKeyDifferentMaster &&
        a.masterKeyTypeId !== this.keyNodeType.SingleKeyDifferentMaster
      )
        return 1
      return 0
    })

    // Move direct change nodes to the top
    masterKey.children.sort((a, b) => {
      if (
        a.masterKeyTypeId === this.keyNodeType.DirectChangeMaster &&
        b.masterKeyTypeId !== this.keyNodeType.DirectChangeMaster
      )
        return -1
      if (
        b.masterKeyTypeId === this.keyNodeType.DirectChangeMaster &&
        a.masterKeyTypeId !== this.keyNodeType.DirectChangeMaster
      )
        return 1
      return 0
    })

    // Move Selective Masters to the top
    masterKey.children.sort((a, b) => {
      if (
        a.masterKeyTypeId === this.keyNodeType.SelectiveMaster &&
        b.masterKeyTypeId !== this.keyNodeType.SelectiveMaster
      )
        return -1
      if (
        b.masterKeyTypeId === this.keyNodeType.SelectiveMaster &&
        a.masterKeyTypeId !== this.keyNodeType.SelectiveMaster
      )
        return 1
      return 0
    })

    // Move Control Keys Keys to the top
    masterKey.children.sort((a, b) => {
      if (
        a.masterKeyTypeId === this.keyNodeType.ControlKeyMaster &&
        b.masterKeyTypeId !== this.keyNodeType.ControlKeyMaster
      )
        return -1
      if (
        b.masterKeyTypeId === this.keyNodeType.ControlKeyMaster &&
        a.masterKeyTypeId !== this.keyNodeType.ControlKeyMaster
      )
        return 1
      return 0
    })

    // Move Construction Keys to the top
    masterKey.children.sort((a, b) =>
      a.masterKeyTypeId === this.keyNodeType.ConstructionKeyMaster
        ? -1
        : b.masterKeyTypeId === this.keyNodeType.ConstructionKeyMaster
        ? 1
        : 0
    )
    masterKey.children.sort((a, b) =>
      a.masterKeyTypeId === this.keyNodeType.Insert ? -1 : b.masterKeyTypeId === this.keyNodeType.Insert ? 1 : 0
    )

    // Move cross keyed cylinders to the bottom
    masterKey.children.sort((a, b) => {
      if (
        a.masterKeyTypeId === this.keyNodeType.CrossKeyMaster &&
        b.masterKeyTypeId !== this.keyNodeType.CrossKeyMaster
      )
        return 1
      if (
        b.masterKeyTypeId === this.keyNodeType.CrossKeyMaster &&
        a.masterKeyTypeId !== this.keyNodeType.CrossKeyMaster
      )
        return -1
      return 0
    })

    // Move Orphans to the bottom
    masterKey.children.sort((a, b) => {
      if (a.masterKeyTypeId === this.keyNodeType.OrphanMaster && b.masterKeyTypeId !== this.keyNodeType.OrphanMaster)
        return 1
      if (b.masterKeyTypeId === this.keyNodeType.OrphanMaster && a.masterKeyTypeId !== this.keyNodeType.OrphanMaster)
        return -1
      return 0
    })

    masterKey.children.forEach((child) => {
      this.sort(child)
    })
  }

  assignParents(masterKey: MasterKey) {
    if (masterKey === null) {
      return
    }
    if (masterKey.masterKeyTypeId === 13) {
      this.masterKeys$.pipe(take(1)).subscribe((mks) => {
        if (!mks) {
          return
        }

        let mkArray = mks.squashIncludeChangeKeys()

        masterKey.children.map((c) => {
          const crossKeyOperator = mkArray.find((key) => c.id === key.id)

          if (
            crossKeyOperator &&
            crossKeyOperator.parent &&
            !crossKeyOperator?.parent?.crossKeyAssignments.find((key) => key.id === masterKey.id)
          ) {
            crossKeyOperator.parent.crossKeyAssignments.push(masterKey)
          }
        })
      })
    }

    if (!masterKey.children) {
      return
    }

    for (const child of masterKey.children) {
      child.parent = masterKey
      child.parentId = masterKey.id
      this.assignParents(child)
    }
  }

  trackLines(masterKey: MasterKey) {
    if (masterKey.parent) {
      const siblings = masterKey.parent.children
      const index = siblings.indexOf(masterKey)
      const isLastChild = index === siblings.length - 1

      // Set lineTracker for this level: true if last child, false otherwise
      masterKey.lineTracker[masterKey.level] = {
        key: masterKey.keySetSymbol,
        value: isLastChild,
      }
    }

    if (masterKey.children && masterKey.children.length > 0) {
      masterKey.children.forEach((child) => {
        // Copy parent's lineTracker to child
        Object.keys(masterKey.lineTracker).forEach((line) => {
          child.lineTracker[line] = masterKey.lineTracker[line]
        })

        // Recursively track lines for children
        this.trackLines(child)
      })
    }
  }

  selectMasterKey(masterKey: MasterKey) {
    const selectedMasters = this.selectedMasters.value
    selectedMasters.push(masterKey)
    this.selectedMasters.next(selectedMasters)
  }

  bulkSelectMasters(masterKeys: MasterKey[]): void {
    this.selectedMasters.next(masterKeys)
  }

  deSelectMasterKey(masterKey: MasterKey) {
    const selectedMasters = this.selectedMasters.value
    const index = selectedMasters.indexOf(masterKey)
    selectedMasters.splice(index, 1)
    this.selectedMasters.next(selectedMasters)
  }

  deSelectAllMasterKeys() {
    for (const master of this.masterKeys.value.squashIncludeChangeKeys()) {
      master.checked = false
      master.isMasterOperator = false
      master.directChangesOperate = false
      master.indeterminateCheckBox = false
      master.disabledCheckBox = false
    }
    this.selectedMasters.next([])
  }

  setChangeKeyParent(master: MasterKey, type: 'Alike' | 'Different') {
    this.selectedChangeKeyType = type
    this.changeKeyParent.next(master)
  }

  private formatItem(hierarchyItem: MasterKey): MasterKey {
    hierarchyItem = Object.assign(new MasterKey(), hierarchyItem)
    if (hierarchyItem.children && hierarchyItem.children.length > 0) {
      for (let i = 0; i < hierarchyItem.children.length; i++) {
        hierarchyItem.children[i] = this.formatItem(hierarchyItem.children[i])
        // hierarchyItem.children[i].isMinimized = true
      }
    }
    return (this.msTest = hierarchyItem)
  }

  /* istanbul ignore next */
  processHierarchy(masterKey: MasterKey) {
    let shouldShow = false
    // Check if the current masterKey is not assigned
    if (
      !masterKey.isTMK &&
      !masterKey.isAssigned &&
      !masterKey.isFutureKey &&
      masterKey.masterKeyTypeId !== this.keyNodeType.ControlKey &&
      masterKey.masterKeyTypeId !== this.keyNodeType.CrossKeyChild &&
      masterKey.masterKeyTypeId !== this.keyNodeType.ControlKeyMaster &&
      masterKey.masterKeyTypeId !== 101
    ) {
      shouldShow = true
    }

    // Check for dummy nodes and set shouldShow to false
    // Else If there are children, recursively check each one
    if (
      masterKey.masterKeyTypeId === this.keyNodeType.OrphanMaster ||
      masterKey.masterKeyTypeId === this.keyNodeType.ConstructionKeyMaster ||
      masterKey.masterKeyTypeId === this.keyNodeType.CrossKeyMaster
    ) {
      shouldShow = false
    } else if (
      masterKey.children &&
      masterKey.children.length > 0 &&
      masterKey.masterKeyTypeId !== this.keyNodeType.ControlKeyMaster &&
      !masterKey.isTMK &&
      masterKey.masterKeyTypeId !== this.keyNodeType.CrossKeyChild
    ) {
      for (let child of masterKey.children) {
        // Recursively update children
        if (this.processHierarchy(child)) {
          shouldShow = true
        }
      }
    }

    // Update the showOnUnassignedToggle property based on the check
    masterKey.showOnUnassignedToggle = shouldShow
    // Return whether this key or any of its children should be shown
    return shouldShow
  }

  // yieldToMain() {
  //   console.log('Yielding...')
  //   return new Promise((resolve) => {
  //     setTimeout(resolve, 0)
  //   })
  // }
}
